import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrowserStorageService } from '../services/browser-storage.service';
import { SessionService } from '../services/session.service';

export const BYPASS_SCHEMA = new HttpContextToken(() => false);

@Injectable()
export class SignedTokenInterceptor implements HttpInterceptor {
  storageManager: BrowserStorageService = new BrowserStorageService();
  constructor(private session: SessionService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.context.get(BYPASS_SCHEMA) === true)
      return next.handle(request);
    else {
      const sessionStorageToken = this.storageManager.get(
        'signedToken',
        'session'
      );

      this.session.token$.subscribe(queryParamToken => {
        request = request.clone({
          headers: request.headers.append(
            'Authorization',
            sessionStorageToken || queryParamToken || ''
          ),
        });
      });

      return next.handle(request);
    }
  }
}
